import type { SVGProps } from "react";

export function Tent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M3 20h18" />
      <path d="M4 20L12 4l8 16" />
      <path d="M9 20l3-6 3 6" />
    </svg>
  );
}
